import * as Sentry from "@sentry/react"

const promiseWithResolvers = Promise as PromiseConstructor & {
  withResolvers?: <T>() => {
    promise: Promise<T>
    resolve: (value: T | PromiseLike<T>) => void
    reject: (reason?: unknown) => void
  }
}

if (!promiseWithResolvers.withResolvers) {
  promiseWithResolvers.withResolvers = <T,>() => {
    let resolve: (value: T | PromiseLike<T>) => void
    let reject: (reason?: unknown) => void

    const promise = new Promise<T>((innerResolve, innerReject) => {
      resolve = innerResolve
      reject = innerReject
    })

    return { promise, resolve: resolve!, reject: reject! }
  }
}

Sentry.init({
  dsn: "https://3df0e8b8ac3988e5fa877882d707121c@o4509712797925376.ingest.us.sentry.io/4510699112824832",
  sendDefaultPii: true,
})

import ReactDOM from "react-dom/client"
import App from "./App.tsx"
import "./index.css"

import { BrowserRouter } from "react-router-dom"
import { ClerkProvider } from "@clerk/react"
import { ClerkTokenSetup } from "./components/ClerkTokenSetup.tsx"
import ErrorBoundary from "./components/ErrorBoundary.tsx"
import PublicIssueApp from "./components/public/PublicIssueApp"

// Validate Clerk publishable key
const clerkPubKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY
const publicIssueEntry = window.location.pathname.startsWith("/public/issues/")
if (!publicIssueEntry && !clerkPubKey) {
  throw new Error("Missing VITE_CLERK_PUBLISHABLE_KEY environment variable")
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  // <React.StrictMode>
  <ErrorBoundary>
    {publicIssueEntry ? (
      <BrowserRouter>
        <PublicIssueApp />
      </BrowserRouter>
    ) : (
      <ClerkProvider publishableKey={clerkPubKey}>
        <ClerkTokenSetup>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ClerkTokenSetup>
      </ClerkProvider>
    )}
  </ErrorBoundary>,
  // </React.StrictMode>,
)
